import { actions } from './remainder/actions'
import { getters } from './remainder/getters'
import { state } from './remainder/state'
import { mutations } from './remainder/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
